import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Dashboard from "features/dashboard";
import Login from "features/auth/login";
import User from "features/user";
import { DashboardLayout } from "components";
import Restaurant from "features/restaurant";
import ShipperList from "features/shipper/list";
import ShipperMap from "features/shipper/map";
import NewOrderLive from "features/order/new-live";
import NewOrder from "features/order/new";
import HistoryOrder from "features/order/history";
import BannerUser from "features/banner/app-user";
import BannerMerchant from "features/banner/app-merchant";
import Campaign from "features/campaign";
import FlashSale from "features/flashsale";
import Collection from "features/collection";
import AdList from "features/ad/list";
import AdType from "features/ad/type";
import Voucher from "features/voucher";
import Notification from "features/notification";
import RestaurantReview from "features/review/restaurant";
import ShipperReview from "features/review/shipper";
import Contact from "features/contact";
import WalletRequest from "features/wallet-request";
import ShipperRewards from "features/setup/shipper-rewards";
import Account from "features/account";
import Category from "features/category";
import Private from "components/common/private";
import Message from "features/message";
import SystemConfig from "features/setup/system-config";
import RestaurantRevenue from "features/report/restaurant-revenue";
import Region from "features/region";
import SuperAccount from "features/super-account";
import Event11 from "features/super-setup/event-1-1";
import MapService from "features/super-setup/map-service";
import RestaurantLabel from "features/restaurant-label";
import RestaurantIdentity from "features/restaurant-identity";
import RestaurantContract from "features/restaurant-contract";
import System from "features/super-setup/system";
import SuperWalletRequest from "features/super-wallet-request";
import Wallet from "features/wallet";
import StatsOtp from "features/super-stats/otp";
import StatsMapRequest from "features/super-stats/map-request";
import StatsEmail from "features/super-stats/email";

import FoodFeeCharge from "features/food-setup/fee-charger";
import FoodHotKeywords from "features/food-setup/hot-keyword";
import FoodBlackRestaurants from "features/food-setup/black-restaurants";

import BikeDashboard from "features/bike-dashboard";
import BikePlace from "features/bike-place";
import BikeVoucher from "features/bike-voucher";
import BikeCombo from "features/bike-combo";
import BikeComboTransaction from "features/bike-combo-transaction";
import BikeFeeCharge from "features/bike-setup/fee-charger";
import BikeOrder from "features/bike-order/history";
import BikeNewOrder from "features/bike-order/new";
import BikeNewOrderLive from "features/bike-order/new-live";

import ExpressDashboard from "features/express-dashboard";
import ExpressVoucher from "features/express-voucher";
import ExpressCombo from "features/express-combo";
import ExpressComboTransaction from "features/express-combo-transaction";
import ExpressFeeCharge from "features/express-setup/fee-charger";
import ExpressOrder from "features/express-order/history";
import ExpressNewOrder from "features/express-order/new";
import ExpressNewOrderLive from "features/express-order/new-live";

import DriverDashboard from "features/driver-dashboard";
import DriverVoucher from "features/driver-voucher";
import DriverFeeCharge from "features/driver-setup/fee-charger";
import DriverOrder from "features/driver-order/history";
import DriverNewOrder from "features/driver-order/new";
import DriverNewOrderLive from "features/driver-order/new-live";

export const routers = {
  dashboard: "food/dashboard",
  login: "dang-nhap",
  region: "phan-cum",
  superAccount: "quan-tri-vien",
  superWalletRequest: "nap-rut-vi",
  superSetup: {
    index: "cai-dat-chung",
    system: "system",
    event: "event-1-1",
    mapService: "map-service",
  },
  superStats: {
    index: "thong-ke",
    otp: "otp",
    mapRequest: "map-request",
    email: "email",
  },
  restaurant: "nha-hang",
  shipper: {
    index: "tai-xe",
    list: "danh-sach",
    map: "vi-tri",
  },
  user: "nguoi-dung",
  account: "tai-khoan",
  category: "danh-muc",
  banner: {
    index: "banner",
    user: "app-user",
    merchant: "app-merchant",
  },
  campaign: "chien-dich",
  flashSale: "flash-sale",
  restaurantLabel: "nhan-quan",
  restaurantIdentity: "can-cuoc-cong-dan",
  restaurantContract: "hop-dong",
  ad: {
    index: "quang-cao",
    list: "danh-sach",
    type: "loai-quang-cao",
  },
  collection: "bo-suu-tap",
  voucher: "food/voucher",
  notification: "thong-bao",
  message: "tin-nhan",
  review: {
    index: "danh-gia",
    restaurant: "nha-hang",
    shipper: "tai-xe",
  },
  contact: "lien-he",
  walletRequest: "lenh-nap-rut-tien",
  wallet: "vi-cum",
  setup: {
    index: "cai-dat-khac",
    system: "he-thong",
    rewards: "thuong-tai-xe",
  },
  report: {
    index: "bao-cao",
    restaurantRevenue: "doanh-thu-quan",
  },
  food: {
    index: "food",
    order: {
      index: "don-hang",
      live: "truc-tiep",
      new: "moi",
      history: "lich-su",
    },
    setup: {
      index: "cai-dat",
      feeCharge: "phi-chiet-khau",
      hotKeyword: "tu-khoa-noi-bat",
      blackRestaurants: "quan-bi-han-che",
      other: "khac",
    },
  },
  bike: {
    index: "bike",
    dashboard: "dashboard",
    place: "dia-diem-goi-y",
    combo: "goi-tiet-kiem",
    comboTransaction: "lich-su-mua-goi",
    voucher: "voucher",
    order: {
      index: "don-hang",
      live: "truc-tiep",
      new: "moi",
      history: "lich-su",
    },
    setup: {
      index: "cai-dat",
      feeCharge: "phi-chiet-khau",
    },
  },
  express: {
    index: "express",
    dashboard: "dashboard",
    combo: "goi-tiet-kiem",
    comboTransaction: "lich-su-mua-goi",
    voucher: "voucher",
    order: {
      index: "don-hang",
      live: "truc-tiep",
      new: "moi",
      history: "lich-su",
    },
    setup: {
      index: "cai-dat",
      feeCharge: "phi-chiet-khau",
    },
  },
  driver: {
    index: "driver",
    dashboard: "dashboard",
    voucher: "voucher",
    order: {
      index: "don-hang",
      live: "truc-tiep",
      new: "moi",
      history: "lich-su",
    },
    setup: {
      index: "cai-dat",
      feeCharge: "phi-chiet-khau",
    },
  },
  // userDetail: (id) => (id ? `/user/${id}` : "/user"),
};

const Routers = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<DashboardLayout />}>
          <Route index element={<Navigate to="/food/dashboard" replace />} />
          <Route
            path="food/dashboard"
            element={<Private component={Dashboard} />}
          />
          <Route
            path={routers.region}
            element={<Private component={Region} />}
          />
          <Route
            path={routers.superAccount}
            element={<Private component={SuperAccount} />}
          />
          <Route
            path={routers.superWalletRequest}
            element={<Private component={SuperWalletRequest} />}
          />
          <Route path={routers.superSetup.index}>
            <Route
              path={routers.superSetup.event}
              element={<Private component={Event11} />}
            />
            <Route
              path={routers.superSetup.mapService}
              element={<Private component={MapService} />}
            />
            <Route
              path={routers.superSetup.system}
              element={<Private component={System} />}
            />
          </Route>
          <Route path={routers.superStats.index}>
            <Route
              path={routers.superStats.otp}
              element={<Private component={StatsOtp} />}
            />
            <Route
              path={routers.superStats.mapRequest}
              element={<Private component={StatsMapRequest} />}
            />
            <Route
              path={routers.superStats.email}
              element={<Private component={StatsEmail} />}
            />
          </Route>
          <Route
            path={routers.account}
            element={<Private component={Account} />}
          />
          <Route
            path={routers.category}
            element={<Private component={Category} />}
          />
          <Route
            path={routers.restaurant}
            element={<Private component={Restaurant} />}
          />
          <Route path={routers.shipper.index}>
            <Route
              path={routers.shipper.list}
              element={<Private component={ShipperList} />}
            />
            <Route
              path={routers.shipper.map}
              element={<Private component={ShipperMap} />}
            />
          </Route>
          <Route path={routers.user} element={<Private component={User} />} />
          <Route path={routers.banner.index}>
            <Route
              path={routers.banner.user}
              element={<Private component={BannerUser} />}
            />
            <Route
              path={routers.banner.merchant}
              element={<Private component={BannerMerchant} />}
            />
          </Route>
          <Route
            path={routers.campaign}
            element={<Private component={Campaign} />}
          />
          <Route
            path={routers.flashSale}
            element={<Private component={FlashSale} />}
          />
          <Route
            path={routers.restaurantLabel}
            element={<Private component={RestaurantLabel} />}
          />
          <Route
            path={routers.restaurantIdentity}
            element={<Private component={RestaurantIdentity} />}
          />
          <Route
            path={routers.restaurantContract}
            element={<Private component={RestaurantContract} />}
          />
          <Route
            path={routers.collection}
            element={<Private component={Collection} />}
          />

          <Route path={routers.ad.index}>
            <Route
              path={routers.ad.list}
              element={<Private component={AdList} />}
            />
            <Route
              path={routers.ad.type}
              element={<Private component={AdType} />}
            />
          </Route>
          <Route
            path={routers.voucher}
            element={<Private component={Voucher} />}
          />
          <Route
            path={routers.notification}
            element={<Private component={Notification} />}
          />
          <Route
            path={routers.message}
            element={<Private component={Message} />}
          />
          <Route path={routers.review.index}>
            <Route
              path={routers.review.restaurant}
              element={<Private component={RestaurantReview} />}
            />
            <Route
              path={routers.review.shipper}
              element={<Private component={ShipperReview} />}
            />
          </Route>
          <Route
            path={routers.contact}
            element={<Private component={Contact} />}
          />
          <Route
            path={routers.walletRequest}
            element={<Private component={WalletRequest} />}
          />
          <Route
            path={routers.wallet}
            element={<Private component={Wallet} />}
          />
          <Route path={routers.setup.index}>
            {/* <Route
              path={routers.setup.feeCharge}
              element={<Private component={FeeCharge} />}
            />
            <Route
              path={routers.setup.hotKeyword}
              element={<Private component={HotKeywords} />}
            />
            <Route
              path={routers.setup.blackRestaurants}
              element={<Private component={BlackRestaurants} />}
            /> */}
            <Route
              path={routers.setup.system}
              element={<Private component={SystemConfig} />}
            />
            <Route
              path={routers.setup.rewards}
              element={<Private component={ShipperRewards} />}
            />
          </Route>
          <Route path={routers.report.index}>
            <Route
              path={routers.report.restaurantRevenue}
              element={<Private component={RestaurantRevenue} />}
            />
          </Route>
          <Route path={routers.bike.index}>
            <Route
              path={routers.bike.dashboard}
              element={<Private component={BikeDashboard} />}
            />
            <Route
              path={routers.bike.place}
              element={<Private component={BikePlace} />}
            />
            <Route
              path={routers.bike.voucher}
              element={<Private component={BikeVoucher} />}
            />
            <Route
              path={routers.bike.combo}
              element={<Private component={BikeCombo} />}
            />
            <Route
              path={routers.bike.comboTransaction}
              element={<Private component={BikeComboTransaction} />}
            />
            <Route path={routers.bike.order.index}>
              <Route
                path={routers.bike.order.live}
                element={<Private component={BikeNewOrderLive} />}
              />
              <Route
                path={routers.bike.order.new}
                element={<Private component={BikeNewOrder} />}
              />
              <Route
                path={routers.bike.order.history}
                element={<Private component={BikeOrder} />}
              />
            </Route>
            <Route path={routers.bike.setup.index}>
              <Route
                path={routers.bike.setup.feeCharge}
                element={<Private component={BikeFeeCharge} />}
              />
            </Route>
          </Route>
          <Route path={routers.express.index}>
            <Route
              path={routers.express.dashboard}
              element={<Private component={ExpressDashboard} />}
            />
            <Route
              path={routers.express.voucher}
              element={<Private component={ExpressVoucher} />}
            />
            <Route
              path={routers.express.combo}
              element={<Private component={ExpressCombo} />}
            />
            <Route
              path={routers.express.comboTransaction}
              element={<Private component={ExpressComboTransaction} />}
            />
            <Route path={routers.express.order.index}>
              <Route
                path={routers.express.order.live}
                element={<Private component={ExpressNewOrderLive} />}
              />
              <Route
                path={routers.express.order.new}
                element={<Private component={ExpressNewOrder} />}
              />
              <Route
                path={routers.express.order.history}
                element={<Private component={ExpressOrder} />}
              />
            </Route>
            <Route path={routers.express.setup.index}>
              <Route
                path={routers.express.setup.feeCharge}
                element={<Private component={ExpressFeeCharge} />}
              />
            </Route>
          </Route>
          <Route path={routers.food.index}>
            <Route path={routers.food.order.index}>
              <Route
                path={routers.food.order.live}
                element={<Private component={NewOrderLive} />}
              />
              <Route
                path={routers.food.order.new}
                element={<Private component={NewOrder} />}
              />
              <Route
                path={routers.food.order.history}
                element={<Private component={HistoryOrder} />}
              />
            </Route>
            <Route path={routers.food.setup.index}>
              <Route
                path={routers.food.setup.feeCharge}
                element={<Private component={FoodFeeCharge} />}
              />
              <Route
                path={routers.food.setup.hotKeyword}
                element={<Private component={FoodHotKeywords} />}
              />
              <Route
                path={routers.food.setup.blackRestaurants}
                element={<Private component={FoodBlackRestaurants} />}
              />
            </Route>
          </Route>
          <Route path={routers.driver.index}>
            <Route
              path={routers.driver.dashboard}
              element={<Private component={DriverDashboard} />}
            />
            <Route
              path={routers.driver.voucher}
              element={<Private component={DriverVoucher} />}
            />
            <Route path={routers.driver.order.index}>
              <Route
                path={routers.driver.order.live}
                element={<Private component={DriverNewOrderLive} />}
              />
              <Route
                path={routers.driver.order.new}
                element={<Private component={DriverNewOrder} />}
              />
              <Route
                path={routers.driver.order.history}
                element={<Private component={DriverOrder} />}
              />
            </Route>
            <Route path={routers.driver.setup.index}>
              <Route
                path={routers.driver.setup.feeCharge}
                element={<Private component={DriverFeeCharge} />}
              />
            </Route>
          </Route>
        </Route>
        <Route path={routers.login} element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
